// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ZhydV","colBig":"styles_colBig__1A5Mn","colSmall":"styles_colSmall__3zHn8"};